import React, { useMemo, memo } from 'react'
import moment from 'moment'

const FindTutorClassBannerCalendarTimeSlot = ({ children: { props }, slots, value }) => {
  const timeDetector = useMemo(() => {
    if (!slots.length) {
      return {
        isEmpty: true,
      }
    }

    const day = moment(value).format('YYYY-MM-DD')
    const hour = moment(value).format('H')
    const found = slots.find((slot) => slot.slot === hour && slot.day === day)

    return {
      isEmpty: !found,
    }
  }, [value, slots])

  return props.children
    ? moment(value).format('HH:mm')
    : !timeDetector.isEmpty && <div className="w-full h-full bg-[#1AC057]" />
}

export default memo(FindTutorClassBannerCalendarTimeSlot)
